export type CookieChoice = 'analytics' | 'essential';

export const cookieChoiceStorageKey = 'truekarat-cookie-choice-v1';
export const cookieChoiceEvent = 'truekarat-cookie-choice';

export const readCookieChoice = (): CookieChoice | null => {
  try {
    const value = window.localStorage.getItem(cookieChoiceStorageKey);
    return value === 'analytics' || value === 'essential' ? value : null;
  } catch {
    return null;
  }
};

export const saveCookieChoice = (choice: CookieChoice) => {
  window.localStorage.setItem(cookieChoiceStorageKey, choice);
  window.dispatchEvent(new CustomEvent<CookieChoice>(cookieChoiceEvent, { detail: choice }));
};
